import { GET_WITHOUT_PERMISSION_PACKAGES } from "../types";

const initialState = { list: [], single: null, cities: [] };

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_WITHOUT_PERMISSION_PACKAGES:
      return { ...state, list: payload };

    default:
      return state;
  }
};

export default reducer;
